<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 28.8403C4.53361 26.2731 6.77642 24.3995 9.37231 24.3995H15.6993C18.2952 24.3995 20.538 26.2731 21.0716 28.8403L20.3229 29C19.8627 26.7857 17.9278 25.1745 15.6993 25.1745H9.37231C7.14389 25.1745 5.20897 26.7857 4.74872 29L4 28.8403Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.88196 16.2381C7.99916 13.864 9.93383 12 12.2808 12C14.6277 12 16.5624 13.864 16.6796 16.2381L16.7446 17.554L16.6796 18.8698C16.5624 21.2439 14.6277 23.1079 12.2808 23.1079C9.93383 23.1079 7.99916 21.2439 7.88196 18.8698L7.817 17.554L7.88196 16.2381ZM12.2808 12.775C10.3416 12.775 8.74298 14.3152 8.64614 16.2769L8.58309 17.554L8.64614 18.8311C8.74298 20.7927 10.3416 22.3329 12.2808 22.3329C14.22 22.3329 15.8186 20.7927 15.9154 18.8311L15.9785 17.554L15.9154 16.2768C15.8186 14.3152 14.22 12.775 12.2808 12.775Z"
      class="fill-current"
    />
    <path d="M22.7376 14.9707H36V16.02H22.7376V14.9707Z" class="fill-current" />
    <path d="M22.7376 17.554H28.8587V18.5872H22.7376V17.554Z" class="fill-current" />
    <path d="M22.7376 26.3369H28.8587V27.3702H22.7376V26.3369Z" class="fill-current" />
    <path d="M29.8789 17.554H36V18.5872H29.8789V17.554Z" class="fill-current" />
  </svg>
</template>
